import { render, staticRenderFns } from "./PersonDialogDataTabComponent.vue?vue&type=template&id=7445f576&scoped=true"
import script from "./PersonDialogDataTabComponent.js?vue&type=script&lang=js&external"
export * from "./PersonDialogDataTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./PersonDialogDataTabComponent.vue?vue&type=style&index=0&id=7445f576&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7445f576",
  null
  
)

export default component.exports